import type {
  IBrokerageDataWeb,
  IBrokerageProfileData,
  IUpdateBrokerageBillingProfileBody,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

export const updateBrokerageBillingProfile = async ({
  billingProfile,
}: {
  billingProfile: IBrokerageProfileData;
}): Promise<IBrokerageDataWeb> => {
  const { data } = await axios.post<
    IBrokerageDataWeb,
    AxiosResponse<IBrokerageDataWeb>,
    IUpdateBrokerageBillingProfileBody
  >('/billing/billing_profile/brokerage', { billingProfile });
  return data;
};
